








FUNCTIONS = require "scripts/common"
module.exports =
	components:
		breadcrumb: require "components/common/breadcrumb"
	computed:
		pageName: -> return this.$route.name
		breadObjects: -> return FUNCTIONS.getSimpleBreadObjects(this.pageName)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/404/404.vue